import { createUseStyles } from 'react-jss'
import { gap } from '../ReportContent/styles'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 8,
    marginTop: gap
  },
  panel: {
    padding: 5,
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    minHeight: 50,
    fontSize: 17,
    fontWeight: 700,
    marginTop: 0
  },
  totalPanel: {
    color: '#fff',
    backgroundColor: '#0078CC'
  }
})

export default useStyles
